// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React from 'react';
import {Add, AddCircleOutline, AddCircle} from '@app/common/icons';
import {Tooltip} from '@app/common';
import {AddBlockWidgetActions} from './add-block-widget-actions';
import cx from 'classnames';

interface AddBlockWidgetProps {
    hideComponent?: any;
    showSingleIcon?: boolean;
    addNewExtensionBlock?: any;
    addNewTextBlock?: any;
    addNewHandoverBlock?: any;
    addNewImageBlock?: any;
    addNewVideoBlock?: any;
    addNewQuoteBlock?: any;
    addNewChoicesBlock?: any;
    addNewCTABlock?: any;
    addNewAttachmentBlock?: any;
    addNewNPSBlock?: any;
    addNewCSATBlock?: any;
    addNewCESBlock?: any;
}

export class AddBlockWidget extends React.Component<AddBlockWidgetProps> {
    state = {
        showActions: false,
    };

    hideActions = () => {
        this.setState({showActions: false});
        this.props.hideComponent();
    };
    handleClickAddBlock = () => {
        this.setState({showActions: true});
    };

    render() {
        /* Defines whether the component renders the smaller plus icon between blocks
         * or the bigger icon which is displayed at the end of the block list.
         */
        const {showSingleIcon} = this.props;
        const {showActions} = this.state;
        const className = cx('add-block-widget', {
            'add-block-widget--actions-visible': showActions,
        });
        const Icon = showActions ? AddCircle : AddCircleOutline;
        return (
            <section className={className}>
                <div className="add-button">
                    <div className="side-line" />
                    <Tooltip
                        overlay={
                            <AddBlockWidgetActions
                                hideActions={this.hideActions}
                                {...this.props}
                            />
                        }
                        tooltipProps={{visible: showActions}}
                    >
                        {showSingleIcon ? (
                            <Icon
                                size={20}
                                onClick={this.handleClickAddBlock}
                            />
                        ) : (
                            <Add size={12} onClick={this.handleClickAddBlock} />
                        )}
                    </Tooltip>
                    <div className="side-line" />
                </div>
            </section>
        );
    }
}
